const SECTION_SELECTOR = '.shopify-section:has(.past-projects-carousel-header)';
const TABLET_MIN = 750;
const DESKTOP_MIN = 1200;

/**
 * Past Projects carousel: pin slide widths before the first arrow click.
 * Slideshow scroll targets use offsetLeft, which can stay 0 until layout
 * settles — making next()/previous() a no-op while still advancing `current`
 * and disabling the arrow. Mobile (1-up) and tablet (2-up) both need this;
 * desktop (≥1200) shows all columns with arrows hidden.
 */
function initPastProjectsCarousels(root = document) {
  root.querySelectorAll(`${SECTION_SELECTOR} slideshow-component`).forEach((slideshow) => {
    if (slideshow.dataset.pastProjectsInit === 'true') return;
    slideshow.dataset.pastProjectsInit = 'true';

    const scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller) return;

    let syncFrame = null;

    const syncLayout = () => {
      const cards = scroller.querySelectorAll('.card[data-carousel-card]');
      if (!cards.length) return;

      const viewport = window.innerWidth;

      if (viewport >= DESKTOP_MIN) {
        cards.forEach((card) => {
          card.style.removeProperty('flex');
          card.style.removeProperty('width');
          card.style.removeProperty('min-width');
        });
        return;
      }

      const scrollerWidth = scroller.clientWidth;
      if (!scrollerWidth) return;

      const gap = parseFloat(getComputedStyle(scroller).gap) || 20;
      // Match base.css: 1 card <750, 2 cards 750–1199
      const columns = viewport >= TABLET_MIN ? 2 : 1;
      const slideWidth = (scrollerWidth - gap * (columns - 1)) / columns;

      cards.forEach((card) => {
        card.style.flex = `0 0 ${slideWidth}px`;
        card.style.width = `${slideWidth}px`;
        card.style.minWidth = `${slideWidth}px`;
      });

      // Force layout so offsetLeft is accurate before scroll.to()
      void scroller.offsetWidth;

      const index = typeof slideshow.current === 'number' ? slideshow.current : 0;
      scroller.scrollLeft = index * (slideWidth + gap);
    };

    const scheduleSync = () => {
      if (syncFrame) cancelAnimationFrame(syncFrame);
      syncFrame = requestAnimationFrame(() => {
        syncFrame = requestAnimationFrame(() => {
          syncFrame = null;
          syncLayout();
        });
      });
    };

    scheduleSync();
    setTimeout(scheduleSync, 150);
    setTimeout(scheduleSync, 500);

    scroller.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', scheduleSync, { once: true });
    });

    // Sync immediately before arrow handling — covers late layout on tablet Safari
    slideshow.querySelectorAll('slideshow-arrows .slideshow-control').forEach((control) => {
      control.addEventListener('pointerdown', syncLayout, { capture: true });
    });

    window.addEventListener('resize', scheduleSync, { passive: true });
  });
}

async function bootstrap(root = document) {
  if (customElements.get('slideshow-component')) {
    await customElements.whenDefined('slideshow-component');
  }

  await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  initPastProjectsCarousels(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bootstrap());
} else {
  bootstrap();
}

document.addEventListener('shopify:section:load', (event) => {
  bootstrap(event.target);
});
